import type { KadeweUser } from "~/types";

/*+
 * Middleware to test that the user completed their account setup. That means:
 * - Students need to verify their ID
 * - All users have to complete the account setup
 */
export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (user.value?.student.has_to_verify && !to.path.startsWith(localePath("/register/student"))) {
        console.warn("Account complete: User has to verify their student id", to.path);
        return navigateTo(localePath("/register/student/select"));
    }

    if (
        user.value?.missing_profile_fields?.length > 0 &&
        !to.path.startsWith(localePath("/register/merge/complete-profile"))
    ) {
        console.warn("Account complete: Merge user has missing profile fields", to.path);
        return navigateTo(localePath("/register/merge/complete-profile"));
    }

    if (!user.value?.contact_id && to.path !== localePath("/register/complete-profile")) {
        console.warn("Account complete: User has not completed their account but should have", to.path);
        return navigateTo(localePath("/register/complete-profile"));
    }
});
